<template>
<header class="main-header">
        <!-- Logo -->
        <router-link
            to="/home"
            class="logo"
        >
            <span class="logo-mini"><b>U</b>DR</span>
            <span class="logo-lg"><b>UNL.RECHARGE</b></span>
            </router-link>
            <nav class="navbar navbar-static-top">
                <a
                    href="#"
                    class="sidebar-toggle"
                    data-toggle="push-menu"
                    role="button"
                >
                    <span class="sr-only">Toggle navigation</span>
                    </a>

                    <div class="navbar-custom-menu">
                        <ul class="nav navbar-nav">
                            <div class="pull-left">
                                <select v-model="selected"  @change="lenguajeChanger" class="btn btn-primary">
                                                    <option v-for="option in options" v-bind:value="option.value">
                                                     {{ option.text }}
                                                     </option>
                                                     </select>
                            </div>
                            <li class="dropdown user user-menu">
                                <a
                                    href="#"
                                    class="dropdown-toggle"
                                    data-toggle="dropdown"
                                >
                                    <img
                                        src="../../assets/dist/img/UDR_LOGO.png"
                                        class="user-image"
                                        alt="User Image"
                                    >
                                        <span class="hidden-xs">{{name}}</span>
                                        </a>

                                        <ul class="dropdown-menu">
                                            <!-- User image -->
                                            <li class="user-header">
                                                <img
                                                    src="../../assets/dist/img/UDR_LOGO.png"
                                                    class="img-circle"
                                                    alt="User Image"
                                                >
                                                    <p>
                                                        {{name}} - {{roll}}

                                                    </p>
                                            </li>
                                            <!-- Menu Body -->
                                            <li class="user-body">

                                                <!-- /.row -->
                                            </li>
                                            <!-- Menu Footer-->
                                            <li class="user-footer">

                                                <div class="pull-right">
                                                    <button
                                                        @click="signOut()"
                                                        class="btn btn-default btn-flat"
                                                    >
                                                        <span>{{$t('LOG_OUT')}} </span>
                                                        <i class="fa fa-power-off"></i>
                                                        </button>

                                                </div>
                                            </li>
                                        </ul>
                            </li>
                            <!-- Control Sidebar Toggle Button -->
                            <li>

                            </li>
                        </ul>
                    </div>
            </nav>
</header>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
import Vue from "vue";
export default {
  name: "Cabezera",

  data() {
    return {
      name: "",
      msg: "hi",
      roll: "",
      url: "../../assets/dist/img/user2-160x160.jpg",
      selected: Vue.i18n.locale(),
      options: [
        {
          text: "ESPAÑOL",
          value: "es"
        },
        {
          text: "ENGLISH",
          value: "en"
        }
      ]
    };
  },
  created() {
    setInterval(() => {
      this.inf();
    }, 100);
  },
  methods: {
    inf() {
      let self = this;
      let user = JSON.parse(self.$store.state.user);
      user = user != null || user != undefined ? user.payload : "";
      self.name = user.name + " " + user.lastname;
      self.roll = user.roll;
    },
    signOut() {
      let self = this;
      swal({
        title: this.$t("ARE YOU SURE THAT YOU WANT TO LOG OUT"),
        icon: "warning",
        buttons: ["No", this.$t("YES")],
        dangerMode: false
      }).then(willDelete => {
        if (willDelete) {
          self.$store.dispatch("logOut").then(response => {
            self.$router.push("/");
          });
        } else {
          swal(this.$t("THANKS FOR STAYING WITH US"));
        }
      });
    },
    lenguajeChanger() {
      window.localStorage.setItem("lang", this.selected);
      axios.defaults.headers.common.lang = this.selected;
      Vue.i18n.set(this.selected);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Cabezera.vue